// extracted by mini-css-extract-plugin
module.exports = {"dialog__title":"Dialog_dialog__title__s_jTT","dialog__close-icon":"Dialog_dialog__close-icon__OBZLj"};